var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-theme-con"
  }, [_c('Row', {
    staticClass: "switch-theme",
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('a', {
    on: {
      "click": _vm.setTheme
    }
  }, [_c('Icon', {
    style: ({
      marginTop: '-2px',
      verticalAlign: 'middle'
    }),
    attrs: {
      "color": "#495060",
      "size": 18,
      "type": "paintbucket"
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c84a12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/ThemeDropMenu.vue
// module id = bMlb
// module chunks = 166